import React from "react";
import { Lightning, MagnifyingGlass, X } from "@phosphor-icons/react";

const same = (a, b) => a.length === b.length && a.every((k) => b.includes(k));

// Presets, copy from another buyer, search and the running count.
export function ShareTools({ cat, hidden, onPreset, others, onCopy, q, setQ }) {
  const total = cat.share_groups.reduce((n, g) => n + g.fields.length, 0);
  return (
    <div className="mb-4 space-y-3 border-2 border-black bg-yellow-50 p-3" data-testid="lead-share-tools">
      <div className="flex flex-wrap items-center gap-2">
        <span className="label-mono flex items-center gap-1"><Lightning size={12} weight="fill" /> Quick picks</span>
        {cat.presets.map((p) => {
          const on = same(p.hidden, hidden);
          return (
            <button key={p.key} type="button" onClick={() => onPreset(p)} aria-pressed={on} data-testid={`lead-share-preset-${p.key}`}
                    className={`border-2 border-black px-2.5 py-1 text-[11px] font-bold transition-colors duration-100 ${on ? "bg-black text-white" : "bg-white hover:bg-zinc-100"}`}>
              {p.label}
            </button>
          );
        })}
        <span className="w-full text-[11px] sm:ml-auto sm:w-auto" data-testid="lead-share-count">
          Sending <b>{total - hidden.length}</b> of {total} optional details
        </span>
      </div>
      <div className="flex flex-col gap-2 sm:flex-row">
        <label className="flex flex-1 items-center gap-2 border-2 border-black bg-white px-2">
          <MagnifyingGlass size={14} />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Find a field, e.g. photos or zip"
                 className="w-full bg-transparent py-1.5 text-sm outline-none" data-testid="lead-share-search" />
          {q && <button type="button" onClick={() => setQ("")} aria-label="Clear search" data-testid="lead-share-search-clear"><X size={12} /></button>}
        </label>
        {others.length > 0 && (
          <select value="" onChange={(e) => { const b = others.find((x) => x.key === e.target.value); if (b) onCopy(b); }}
                  className="border-2 border-black bg-white px-2 py-1.5 text-sm" data-testid="lead-share-copy">
            <option value="">Copy another buyer&apos;s choices…</option>
            {others.map((b) => <option key={b.key} value={b.key}>{b.name}</option>)}
          </select>
        )}
      </div>
    </div>
  );
}
